import { SelectionModel } from '@angular/cdk/collections';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import {STEPPER_GLOBAL_OPTIONS} from '@angular/cdk/stepper';
import { MatTableDataSource } from '@angular/material/table';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { TraslateService } from 'src/app/traslate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalService } from 'src/app/local.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-add-favoris-report',
  templateUrl: './add-favoris-report.component.html',
  styleUrls: ['./add-favoris-report.component.scss']
})
export class AddFavorisReportComponent implements OnInit,AfterViewChecked {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  tableDataSource: any[];
  collection:any =[];
  lengthpage: number=100;
  pageSizeOptions1: number[];
  pageNum: any ;
  manualPage: number =0;
  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();
  rangeForm = new FormGroup({
    start: new FormControl(new Date(localStorage.getItem("startDateValue"))),
    end: new FormControl(new Date(localStorage.getItem("endDateValue"))),
  });
  manualPage1: number;
  public currentPage = 0;
  public totalSize = 0;
  pageSizeOptions = [5, 10, 25];
  pageSize1: any;
  pageSize = 5;
  index2:any=10;
  selection = new SelectionModel<any>(true, []);
 selectedRow;
  selected : boolean;
  ItemSelected: any =[];
  highlighted=false;
  selectedRowIndex: number = -1;
  displayedColumns = ["select", "name","type","created_at","typeExport",'action'];
  dataSource = new MatTableDataSource();
  @ViewChild(MatMenuTrigger)
  contextMenu: MatMenuTrigger;
  contextMenuPosition = { x: '0px', y: '0px' };
  CodePostal: any;
  Nom:any;
  Groupe: any;
  itemSelect2: any;
  myModel = true;
  veh:boolean=true;
  scr:boolean=true;
  lengthItem: any =0;
  URL: string;
  lengthTotal: any;
  repos: any;
  arr: any=[];
  url: any;
  sfScMoy:any
  ecScMoy:any
  scoresaf:any
  scoreeco: any
  listItems: any[];
  id: any;
  constructor(private _formBuilder: FormBuilder ,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog ,
              private fb: FormBuilder,
              private http: HttpClient ,
              public traslateService: TraslateService,
              private spinnerreportfav: NgxSpinnerService ,
              private localService:LocalService,
              private cdRef: ChangeDetectorRef
              ) {
    this.getItem()

    this.traslateService.reportfavdataQuote.subscribe(data=>{
      this.url =data
    })
    this.getFavoris(15,"")
  }

   ngOnInit() {
  }
  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
  getValuesf(e){
    //console.log(e)
    this.sfScMoy= e
  }
  getValueec(e){
    //console.log(e)
    this.ecScMoy= e
  }
  pageChanged(event){
    console.log(" pageChanged(event)  pageChanged(event) ")
    console.log(event);
    let pageIndex = event.pageIndex;
    let pageSize = event.pageSize;
    let previousIndex = event.previousPageIndex;
    let previousSize = pageSize * pageIndex;
    console.log("pageSize");
    console.log(pageSize);

    console.log("pageIndex");
    console.log(pageIndex);
this.getFavoris(previousSize ,(pageIndex+1).toString());
  }

  getFavoris(currentSize ,offset){

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

  this.URL = environment.apiUrl+'/reports/favorite'+'?page='+ offset +"&name="+this.searchbyname
  this.http.get(this.URL ,requestOptions).subscribe((response : any)=>{
    var listFavorisAlarm:any =response
    this.lengthTotal = listFavorisAlarm.length
    this.repos =  listFavorisAlarm
    this.collection=[]
    var lgn:any = this.lengthTotal
      this.lengthpage = parseInt("" + (lgn+1) / this.pageSize)
      if (this.lengthpage%2 == 0){
        for (var i = 0; i < this.lengthpage; i++) {
          this.collection.push(i + 1);
        }
      }else{
        for (var i = 0; i < this.lengthpage+1; i++) {
          this.collection.push(i + 1);
        }
      }

      var list: any = response.data

      this.repos =response.data
    this.repos.push(...list);

      if (currentSize == 0 ){
        list.length =15 ;
      }else {
        list.length =currentSize ;
      }

      this.repos =response.data
      this.repos.push(...list);
      this.repos.length = response.meta.total

    //let resultid : any[]=[]
    this.dataSource = new MatTableDataSource(this.repos);
      this.tableDataSource=this.repos ;
      this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  },
  (error) => {
    Swal.fire({
      text: 'Un problème est survenu! '+error,

    })
    this.spinnerreportfav.hide();
  })
  }

  getItemDetails2(e){
   this.checkboxLabel(e)
    this.itemSelect2 =e.ID;
    //console.log(this.itemSelect2)
  }
  onContextMenu(event: MouseEvent, item: any) {
    event.preventDefault();
    this.contextMenuPosition.x = event.clientX + 'px';
    this.contextMenuPosition.y = event.clientY + 'px';
    this.contextMenu.menuData = { 'item': item };
    this.contextMenu.menu.focusFirstItem('mouse');
    this.contextMenu.openMenu();
  }
  onContextMenuAction1(item: any) {
    alert(`Click on Supprimer for ${item.name}`);
  }
  onContextMenuAction2(item: any) {
    alert(`Click on Modifier for ${item.name}`);
  }
  onContextMenuAction3(item: any) {
    alert(`Click on Activer/Désactiver for ${item.name}`);
  }
  /** Whether the number of selected elements matches the total number of rows. */
isAllSelected() {
  const numSelected = this.selection.selected?.length;
  const numRows = this.dataSource.data?.length;
  return numSelected === numRows;
}

 /** Selects all rows if they are not all selected; otherwise clear selection. */
 masterToggle() {

  this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row =>{ this.selection.select(row); });
}
/** The label for the checkbox on the passed row */
checkboxLabel(row) {
  this.ItemSelected = this.selection.selected
  return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;

}
GetSelectedRow(row) {
  if(this.selectedRowIndex===row.ID){
    this.selectedRowIndex=-1;
    this.selected=false;
  }else {

    this.selectedRow=row;
    this.selectedRowIndex=row.ID;
    this.selected=true;
  }
 }
searchbyname : any =""
applyFilter(event: Event) {
  this.getFavoris(15, "") ;
}

public updateManualPage2(index2) {
  this.collection=[]
  this.paginator.pageSize = index2
  this.paginator.page.next({
    pageIndex: this.paginator.pageIndex,
    pageSize: index2,
    length: this.paginator.length
  });
  this.lengthpage = parseInt("" + this.paginator?.length / index2)
   for (var i = 0; i < this.lengthpage; i++) {
    this.collection.push(i+1);
  }
  }

public updateManualPage(index): void {
  //console.log(index)
  this.pageNum =index
  this.manualPage = index;
  this.paginator.pageIndex = index;

  this.paginator.page.next({
    pageIndex: this.paginator.pageIndex,
    pageSize: this.paginator.pageSize,
    length: this.paginator.length
  });
}

supprimerRapport(){
  this.arr = []
  this.selection.selected.forEach(el => {

    this.arr.push(el.id);

  })

  if(this.ItemSelected.length === 1){


    Swal.fire({
      title: "Voulez-vous supprimer le rapport selectionné ?",
      text: "Vous êtes sur le point de supprimer un rapport favoris!",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      cancelButtonText: 'Annuler!',
      confirmButtonText: 'Confirmer!'
    }).then((result) => {
      if (result.isConfirmed) {

        this.http.delete(environment.apiUrl+'/reports/favorite/['+this.arr+']').subscribe((response)=> {
          ////console.log(response)
          var resp:any = response
          if(resp.status ==200){
            this.selection.clear();
            this.lengthItem =0
            this.getFavoris(15 , "")
            Swal.fire({
              text:'',
              html: resp.message.join('<br>')
            }

            )
          }else if(resp.status == false){

            Swal.fire({
              html: resp.message.join('<br>'),
              showCancelButton: true,
              confirmButtonColor: '#262756',
              cancelButtonColor: "#e05a61",
              cancelButtonText: 'Annuler!',
              confirmButtonText: 'Confirmer!'
            }).then((result) => {
              if (result.isConfirmed) {

              this.http.delete(environment.apiUrl+'/reports/favorite/['+this.arr+']/confirm').subscribe((response)=> {
                ////console.log(response)

                if(resp.status ==200){
                  this.selection.clear();
                  this.lengthItem =0
                  this.getFavoris(15 ,"")
                  Swal.fire(
                    '',
                    resp.message

                  ) }

              },
              (error) => {
                Swal.fire({
                  text: 'Un problème est survenu! '+error,

                })


              })


            }})
          }
          else {
            Swal.fire({
              text: 'Une erreur est survenue lors de la suppression',
            })
          }

      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! '+error,

        })


      })
      }
    })

  }
  else if (this.ItemSelected.length >= 1){

    Swal.fire({
      title: "Voulez vous supprimer ces favoris sélectionnés ?",
      text: "",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      cancelButtonText: 'Annuler!',
      confirmButtonText: 'Confirmer!'
    }).then((result) => {
      if (result.isConfirmed) {

        this.http.delete(environment.apiUrl+'/reports/favorite/['+this.arr+']').subscribe((response)=> {
          ////console.log(response)
          var resp:any = response
          if(resp.status ==200){
            ////console.log(environment.apiUrl+'/reports/favorite/['+this.arr+']')


            this.selection.clear();
            this.lengthItem =0
            this.getFavoris(15,"")
            Swal.fire(
              '',
              resp.message
            )
          }else if(resp.status == false){

            Swal.fire({
              html: resp.message.join('<br>'),
              showCancelButton: true,
              confirmButtonColor: '#262756',
              cancelButtonColor: "#e05a61",
              cancelButtonText: 'Annuler!',
              confirmButtonText: 'Confirmer!'
            }).then((result) => {
              if (result.isConfirmed) {

              this.http.delete(environment.apiUrl+'/reports/favorite/['+this.arr+']/confirm').subscribe((response)=> {
                ////console.log(response)
                if(resp.status ==200){
                this.selection.clear();
                this.lengthItem =0
                this.getFavoris(15,"")
                Swal.fire(
                  '',
                  resp.message
                ) }
              })


            }})
          }

          else {


            Swal.fire({
              text: 'Une erreur est survenue lors de la suppression',
            })

          }

      })
      }
    })

  }
  else {

    Swal.fire({
      title: 'Veuillez selectionner un enregistrement'
    })

  }

}

getItem(){
  this.lengthItem =this.selection.selected.length
  ////console.log(this.lengthItem)
 }
 arrfvr:any=[]

supprimerRapport_RightClick(operation, id: any,){
  if (operation == 'oneItem') {
    this.selection.clear()
    this.ItemSelected = []
    this.arrfvr = []
    this.ItemSelected.push({
      id: id,
    })
    console.log("list", this.ItemSelected)
  }
this.arrfvr=[]
  for(var i = 0; i < this.ItemSelected.length; i++) {
    var obj = {}; // <---- Move declaration inside loop

    obj['id'] = this.ItemSelected[i].id;

    this.arrfvr.push(this.ItemSelected[i].id);
}
    Swal.fire({
      title: "Voulez vous supprimer ce favoris ?",
      text: "Vous êtes sur le point de supprimer un rapport des favoris!",
      showCancelButton: true,
      confirmButtonColor: '#262756',
      cancelButtonColor: "#e05a61",
      confirmButtonText: 'Confirmer!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.http.delete(environment.apiUrl+'/reports/favorite/['+this.arrfvr+']').subscribe((response)=> {
          ////console.log(response)
          var resp:any = response
          if(resp.status ==200){
            ////console.log(environment.apiUrl+'/reports/favorite/['+e+']')


            this.selection.clear();
            this.lengthItem =0
            this.getFavoris(15,"")
            Swal.fire(
              '',
              resp.message
            )
          }
          else {
            Swal.fire({
              text: resp.message,
              showCancelButton: true,
              confirmButtonColor: '#262756',
              cancelButtonColor: "#e05a61",
              confirmButtonText: 'Confirmer!'
            }).then((result)=>{
              if (result.isConfirmed) {
                this.http.delete(environment.apiUrl+'/reports/favorite/['+this.arrfvr+']/confirm').subscribe((response)=>
                {
                  var resp:any = response
                  if(resp.status ==200){
                    this.selection.clear();
                    this.lengthItem =0
                    this.getFavoris(15,"")
                    Swal.fire(
                      '',
                      resp.message
                    )
                  }

                })
              }
            })

          }

      })
      }
    })
}

modifierRapport(ee){
    this.selection.clear()
    this.ItemSelected = ee

   let dialogRef= this.dialog.open(DialogEditFavrep,{

      data: {
        animal: 'panda'
      },
      width: '70%',
      height: '90%',
      panelClass: 'my-custom-dialog-class'
    });
    dialogRef.afterClosed().subscribe( result => {
      this.selection.clear()
      this.ItemSelected = []
    })
    this.traslateService.reportfavQuote.next(ee)
    for (let e of ee ) {
      this.Nom=e.name
    }

}
modifierRapport_RightClick(e){
    this.ItemSelected = this.selection.selected
    this.dialog.open(DialogEditFavrep,{

      data: {
        animal: 'panda'
      },
      width: '70%',
      height: '79%',
      panelClass: 'my-custom-dialog-class'
    });

    this.traslateService.reportfavQuote.next(e)

    for (let e of this.ItemSelected ) {
      //console.log(e.CodePostal)
      this.CodePostal=e.CodePostal
      this.Groupe=e.Groupe
      this.Nom=e.name
    }
}
}
@Component({
  selector: 'dialog-elements-example-dialog',
  styleUrls: ['./add-favoris-report.component.scss'],
  templateUrl: 'EditFav.html',
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: {displayDefaultIndicatorType: false}
  }]
})
export class DialogEditFavrep implements OnInit {

  descr_veh:boolean=true
  descr_fl_veh:boolean
  desc_det_veh:boolean
  mode="vehicule"
  desc_fl_cond:boolean;
  desc_det_cond: boolean;
  myModel = true;

  veh:boolean=true;
  scr:boolean=true;
  scr2:boolean=true;
  URL: string;
  URL1: string;
  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();

  rangeForm = new FormGroup({

    start: new FormControl(new Date(localStorage.getItem('startDateValue'))),
    end: new FormControl(new Date(localStorage.getItem('endDateValue'))),
  });

  rap_fl_v:boolean;
  rap_d_v:boolean;

  rap_fl_c:boolean;
  rap_d_c:boolean;

  todo: any=[];

  done : any=[];

    lengthTotal: any;
    repos: any=[];
    dataSource: any;
  itemSelect2: any;
  url: any=[];
  name:any;
  critere:any;
  periode:any;
  scoresf: void;
  scoresf_values: any;
  scoreec_values: any;
  scoresf_op: any;
  scoreec_op: any;
  score_sf1: any;
  score_sf2: any;
  score_ec2: any;
  score_ec1: any;
  op_sf1: any;
  op_sf2: any;
  op_ec1: any;
  op_ec2: any;
  unitsid: any;
  units:any
  drivers:any
  arrid: any=[];
  arr2: any[];
  test: any=[];


  score_sfty_v1:any
  score_sfty_v2:any
  score_eco_v1:any
  score_eco_v2:any
  operator: any;
  operator1: any;
  operator2: any;
  operator3: any;
  op1: any[]= [];
  op2: any[]=[];
  myObjStr: string;
  typerep: number;
  fav_id: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  tableDataSource: any[];

  @Input()

  urlSafe: SafeResourceUrl;
  sfScMoy: any;
  ecScMoy: any;
  avgSF: any;
  avgec: any;

  scoresaf:any
  scoreeco: any
  dateFin:any
  dateDebut:any

    constructor(public dialog: MatDialog ,
                public dialogRef: MatDialogRef<DialogEditFavrep>,
                private _snackBar: MatSnackBar,
                public sanitizer: DomSanitizer,
                private router: Router,
                public traslateService: TraslateService,
                private http: HttpClient,
                private spinnerreportfav: NgxSpinnerService ,
                private localService:LocalService,
                private cdRef: ChangeDetectorRef
    ) {
     }

    ngOnInit(): void {
this.getData()
//this.test=this.arrid
    }
close(){

  this.dialogRef.close();


}

    getFavoris(){

      const headerDict = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
      }

      const requestOptions = {
        headers: new HttpHeaders(headerDict),
      };




    this.URL = environment.apiUrl+'/reports/favorite'
    this.http.get(this.URL ,requestOptions).subscribe((response)=>{

      var listFavorisAlarm:any =response

      this.lengthTotal = listFavorisAlarm.length


      this.repos =  listFavorisAlarm
      //console.log(this.repos)




      //let resultid : any[]=[]
      this.dataSource = new MatTableDataSource(this.repos);
        this.tableDataSource=this.repos ;
        this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    },
    (error) => {
      Swal.fire({
        text: 'Un problème est survenu! '+error,

      })


    })
    }



getValuesf(e){
  //console.log(e)
  this.sfScMoy= e
}
getValueec(e){
  //console.log(e)
  this.ecScMoy= e
}
 getData(){
  this.traslateService.reportfavdataQuote.subscribe(data=>{
    this.url =data
    //console.log(data)

    //console.log( this.url.name)
    //console.log(this.url.filter.split('~')[1])
    //console.log(this.url.filter.split('~')[0])

  var element = this.url
      this.fav_id=element.id
      this.name= element.name;
      this.critere=element.criteria
      this.dateFin=element.filter.split('~')[1]
      this.dateDebut=element.filter.split('~')[0]
      this.scoresf_values=this.critere.safety_score.values
      this.score_sf1=this.scoresf_values[0]
      this.score_sf2=this.scoresf_values[1]
      this.scoreec_values=this.critere.eco_score.values
      this.score_ec1=this.scoreec_values[0]
      this.score_ec2=this.scoreec_values[1]
      this.scoresf_op=this.critere.safety_score.operators
      this.op_sf1=this.scoresf_op[0]
      this.op_sf2=this.scoresf_op[1]
      this.scoreec_op=this.critere.eco_score.operators
      this.op_ec1=this.scoreec_op[0]
      this.op_ec2=this.scoreec_op[1]
      this.scoresaf=this.critere.safety_score.avg
      this.scoreeco=this.critere.eco_score.avg


      if (element.type == 1 && 'units' in this.critere ){

        this.rap_fl_v = true
        this.mode ="vehicule"
        //console.log('hi')
        this.listvehicule()
      }
      else if(element.type == 2 && 'units' in this.critere ){
        this.rap_d_v = true
        this.mode ="vehicule"
        //console.log('hi v')
        this.listvehicule()
      }
      else if(element.type == 1 && 'drivers' in this.critere ){
        this.rap_fl_c = true
        this.mode ="conducteur"
        //console.log('hi c1')
        this.listcond()

      }
      else{
        this.rap_d_c = true
        this.mode ="conducteur"
        //console.log('hi c')
        this.listcond()

      }


      //console.log(this.name)
      // //console.log(this.critere.safety_score.values)



  })
  //console.log(this.url)
 }


 generatePdf(){
  /* const documentDefinition = { content: 'This is an sample PDF printed with pdfMake' };
  pdfMake.createPdf(documentDefinition).open(); */
  this.score_sf1=document.getElementById("score_sfty_v1")
  //console.log(this.score_sf1)
  this.score_sf2=document.getElementById("score_sfty_v2")
  this.score_ec1=document.getElementById("score_eco_v1")
  //console.log(this.score_ec1)

  this.score_ec2=document.getElementById("score_eco_v2")


 let res : any[]=[parseInt(this.score_sf1.value),parseInt(this.score_sf2.value)];
 let res1 : any[]=[parseInt(this.score_ec1.value),parseInt(this.score_ec2.value)];
this.op1=[this.op_sf1,this.op_sf2]
this.op2=[this.op_ec1,this.op_ec2]


 //res.push(this.score_sfty_v1.value)

  //console.log(res)
  //console.log(res1)
  //console.log(this.op1)
  //console.log(this.op2)
  //console.log(this.operator)
//console.log(this.mode)
  this.generate(this.test,this.op1,res,this.op2,res1,this.mode,this.sfScMoy,this.ecScMoy)
  /* let result1 =[]
  result1=this.done
  //console.log(result1) */

 }




 objSec(operators,values,avg){
  //const obj = JSON.stringify({operators,value})
  return {operators,values,avg}
}
objEco(operators,values,avg){
  //const obj1 = JSON.stringify({operators,value})
return {operators,values,avg}
}
generatefav(arr,operatorssf,valuesf,operators_eco,value_eco,mode,avg_sf,avg_ec){

  let safety_score =this.objSec(operatorssf,valuesf,avg_sf)
  let eco_score= this.objEco(operators_eco,value_eco,avg_ec)
  if(mode =="vehicule"){
    var units =arr
    this.myObjStr = JSON.stringify({units,safety_score,eco_score});
    //console.log(encodeURI(this.myObjStr))
    //console.log(this.myObjStr)

  }else {
    var drivers =arr
    this.myObjStr = JSON.stringify({drivers,safety_score,eco_score});
    //console.log(encodeURI(this.myObjStr))
    //console.log(this.myObjStr)

  }}

  generate(arr,operatorssf,valuesf,operators_eco,value_eco,mode,avg_sf,avg_ec){

    let safety_score =this.objSec(operatorssf,valuesf,avg_sf)
    let eco_score= this.objEco(operators_eco,value_eco,avg_ec)
    if(mode =="vehicule"){
      var units =arr
      this.myObjStr = JSON.stringify({units,safety_score,eco_score});
      //console.log(encodeURI(this.myObjStr))
      //console.log(this.myObjStr)

    }else {
      var drivers =arr
      this.myObjStr = JSON.stringify({drivers,safety_score,eco_score});
      //console.log(encodeURI(this.myObjStr))
      //console.log(this.myObjStr)

    }

    if (this.rap_d_v ==true){ this.typerep=2

    }
    else if(this.rap_fl_v ==true){this.typerep=1
    }
    else if(this.rap_d_c == true){this.typerep=2
    }
    else{this.typerep=1
      }

    this.spinnerreportfav.show();

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    var DateFilterStart =  new Date(this.rangeForm.value.start).toString().split('GMT')[0]
    var DateFilterEnd=  new Date(this.rangeForm.value.end).toString().split('GMT')[0]
    var concat = DateFilterStart+'~'+DateFilterEnd
    //console.log(concat)

   this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/reports/type/'+this.typerep+'/filter/'+concat+'/criteria/'+encodeURI(this.myObjStr)
  //console.log(concat)
   this.http.get(this.URL ,requestOptions).subscribe((response)=>{

  //console.log(response)

  var resp:any = response
  this.spinnerreportfav.hide();

  var url:any= resp.url
  this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(resp.url);

  this.dialog.open(PdfDomComponent,{

    data: {
      animal: 'panda'
    },
    width: '70%',
    height: '67%',
    autoFocus: false,

    panelClass: 'my-custom-dialog-class'
  });

  this.traslateService.urlfavPathQuote.next(this.urlSafe)


   },
   (error) => {
     Swal.fire({
       text: 'Un problème est survenu! '+error,

     })


   })

  }




  addfav(){

    this.score_sf1=document.getElementById("score_sfty_v1")
    //console.log(this.score_sf1)
    this.score_sf2=document.getElementById("score_sfty_v2")
    this.score_ec1=document.getElementById("score_eco_v1")
    //console.log(this.score_ec1)

    this.score_ec2=document.getElementById("score_eco_v2")


   let res : any[]=[parseInt(this.score_sf1.value),parseInt(this.score_sf2.value)];
   let res1 : any[]=[parseInt(this.score_ec1.value),parseInt(this.score_ec2.value)];
  this.op1=[this.op_sf1,this.op_sf2]
  this.op2=[this.op_ec1,this.op_ec2]


  var DateFilterStart =  new Date(this.rangeForm.value.start).toString().split('GMT')[0]
  var DateFilterEnd=  new Date(this.rangeForm.value.end).toString().split('GMT')[0]
  var concat = DateFilterStart+'~'+DateFilterEnd
  //console.log(concat)

   //res.push(this.score_sfty_v1.value)

    //console.log(res)
    //console.log(res1)
    //console.log(this.op1)
    //console.log(this.op2)
    //console.log(this.operator)

    this.generatefav(this.test,this.op1,res,this.op2,res1,this.mode,this.sfScMoy,this.ecScMoy)
if (this.rap_d_v=true){ this.typerep=1

  this.rap_d_v=false
}
else if(this.rap_fl_v=true){this.typerep=2

  this.rap_fl_v=false}
else if(this.rap_d_c=true){this.typerep=1}
else{this.typerep=2}

var obj:any =  {name: this.name, type: this.typerep ,filter: concat ,criteria: this.myObjStr}
//console.log(obj)
this.spinnerreportfav.show();

return  this.http.put(environment.apiUrl+'/reports/favorite/'+ this.fav_id, obj).subscribe(data => {
var response:any =data

  if (response.status == 200) {

    this.getFavoris()
    //console.log(response)


    this.spinnerreportfav.hide();
    this.dialogRef.close();
  /*   Swal.fire({
      icon: 'success',
      title: 'Vos modifications ont été effectuer avec succés',
      text: 'Modifications enregistrés!',

    }) */

    Swal.fire({
      position: 'top-end',
      title: 'Vos modifications ont été effectuer avec succés',
      showConfirmButton: false,
      timer: 2500
    })

  }
},
(error) => {
  Swal.fire({
    text: 'Un problème est survenu! '+error,

  })

  this.spinnerreportfav.hide();
})
  }

  resetFormScore() {
    this.operator =null;
    this.operator1 =null;
    this.operator2 =null;
    this.operator3 =null;
    this.op_sf1=null;
    this.op_sf2=null;
    this.op_ec1=null;
    this.op_ec2=null;
    this.name=null;
    this.scoresaf="null";
    this.scoreeco="null";
   (<HTMLFormElement>document.getElementById('score_sfty_v1')).value =null;
   (<HTMLFormElement>document.getElementById('score_sfty_v2')).value =null;
   (<HTMLFormElement>document.getElementById('score_eco_v1')).value =null;
   (<HTMLFormElement>document.getElementById('score_eco_v2')).value =null;
 this.remove()
  }

     show_veh(){
     this.descr_veh=true
     this.mode="vehicule"
     this.desc_fl_cond=false

     this.rap_fl_v=false;
    this.rap_d_v=false;

    this.rap_fl_c=false;
    this.rap_d_c=false;
    //console.log(this.mode)
    this.todo=[]

     }



     executeFunction(){

         this.addNewDate(this.rangeForm)

       }

        addNewDate(e) {

         var DateStart = new Date(e.value.start)?.toString().split('(')[0];
         //this.minDate = new Date(e.value.start)


         var DateEnd2 = new Date(e.value.end)?.toISOString();
         var DateEnd = new Date(e.value.end)?.toString().split('(')[0];
         //console.log(DateEnd2, DateStart, DateEnd)

         if (DateEnd2 != "1970-01-01T00:00:00.000Z") {
           localStorage.setItem('startDateValue',new Date(this.rangeForm.value.start).toString())
           localStorage.setItem('endDateValue',new Date(this.rangeForm.value.end).toString())
           //this.getdd(DateStart, DateEnd)
         } else {
           // this.rangeForm.reset();
         }
       }
       /*

       addNewDate1(e) {



        var DateStart = new Date(e.value.start)?.toString().split('(')[0];
        //this.minDate = new Date(e.value.start)


        var DateEnd2 = new Date(e.value.end)?.toISOString();
        var DateEnd = new Date(e.value.end)?.toString().split('(')[0];
        //console.log(DateEnd2, DateStart, DateEnd)

        if (DateEnd2 != "1970-01-01T00:00:00.000Z") {
          localStorage.setItem('startDateValue',new Date(this.rangeForm.value.start).toString())
          localStorage.setItem('endDateValue',new Date(this.rangeForm.value.end).toString())
         // this.getdd1(DateStart, DateEnd)
        } else {
          // this.rangeForm.reset();
        }
      } */

    /*    getdd(e1, e2) {  const headerDict = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
      }

      const requestOptions = {
        headers: new HttpHeaders(headerDict),
      };

    this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/scores/vehicles/all/filter/' + e1 + '~' + e2

    this.http.get(this.URL ,requestOptions).subscribe((response)=>{

      var listvehiculee:any =response

      this.lengthTotal = listvehiculee.length


      this.repos =  listvehiculee.units
      //console.log(this.repos)






     let result : any[]=[];
     for(let e in this.repos){
      result.push(this.repos[e].name)

     }
  //console.log(result)
  this.todo=result
  //console.log(this.done)
   })




       }
       getdd1(e1, e2) {  const headerDict = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Headers': 'Content-Type',
      }

      const requestOptions = {
        headers: new HttpHeaders(headerDict),
      };

    this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/scores/drivers/all/filter/' + e1 + '~' + e2

    this.http.get(this.URL ,requestOptions).subscribe((response)=>{

      var listconducteur:any =response

      this.lengthTotal = listconducteur.length


      this.repos =  listconducteur.drivers
      //console.log(this.repos)






     let result : any[]=[];
     for(let e in this.repos){
      result.push(this.repos[e].name)

     }
  //console.log(result)
  this.todo=result
  //console.log(this.done)
   })




       } */;
       arr_diff (a1, a2) {

        var a = [], diff = [];

        for (var i = 0; i < a1.length; i++) {
            a[a1[i]] = true;
        }

        for (var i = 0; i < a2.length; i++) {
            if (a[a2[i]]) {
                delete a[a2[i]];
            } else {
                a[a2[i]] = true;
            }
        }

        for (var k in a) {
            diff.push(k);
        }

        return diff;
    }

     listvehicule(){

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/units'
    this.http.get(this.URL ,requestOptions).subscribe((response)=>{
    var listvehiculee:any =response
    this.lengthTotal = listvehiculee.length
    this.repos =  listvehiculee.vehicles
    if ('units' in this.critere){
      this.arrid=this.critere.units
      this.test=this.arrid
      //console.log(this.arrid)
      let resultid : any[]=[]
      let result : any[]=[];
      let id =[]
      let resulttodo=[]
      for(let e in this.repos){

        resultid.push({"id": this.repos[e].id,"name": this.repos[e].name})
        result.push(this.repos[e].name)
       id.push(this.repos[e].id)

        //this.todo.push(this.repos[e].name)

      }
      resulttodo = this.arr_diff(this.arrid,id)
      //console.log(resulttodo)



      this.arr2=[]
      //let result : any[]=[];
      let result1: any[]=[];
      let resultd: any[]=[];

      for(let e in this.repos){
        for(let i in resulttodo){
            if(this.repos[e].id == resulttodo[i] ){


              result1.push({"id": this.repos[e].id,"name": this.repos[e].name})
                }
        }


      }
      for(let e in this.repos){
        for(let i in this.arrid){
            if(this.repos[e].id == this.arrid[i] ){
              resultd.push({"id": this.repos[e].id,"name": this.repos[e].name})
                }
        }


      }
      //console.log(result1)
      //console.log(resulttodo)
      //console.log(resultd)
      this.done=resultd
     //console.log(result)
     this.todo=result1
     ////console.log(this.done)
    }
    else{

      return

    }



  },
  (error) => {
    Swal.fire({
      text: 'Un problème est survenu! '+error,

    })


  })

  }

  listcond(){

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };




  this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/drivers'
  this.http.get(this.URL ,requestOptions).subscribe((response)=>{

    var listconducteurs:any =response

    this.lengthTotal = listconducteurs.length


    this.repos =  listconducteurs.drivers
    //console.log(this.repos)

    if ('drivers' in this.critere){
      this.arrid=this.critere.drivers
      //console.log(this.arrid)
      this.test=this.arrid
      //console.log(this.arrid)
      let resultid : any[]=[]
      let result : any[]=[];
      let id =[]
      let resulttodo=[]
      for(let e in this.repos){

        resultid.push({"id": this.repos[e].id,"name": this.repos[e].name})
        result.push(this.repos[e].name)
       id.push(this.repos[e].id)

        //this.todo.push(this.repos[e].name)

      }
      resulttodo = this.arr_diff(this.arrid,id)
      //console.log(resulttodo)



      this.arr2=[]
      //let result : any[]=[];
      let result1: any[]=[];
      let resultd: any[]=[];

      for(let e in this.repos){
        for(let i in resulttodo){
            if(this.repos[e].id == resulttodo[i] ){


              result1.push({"id": this.repos[e].id,"name": this.repos[e].name})
                }
        }


      }
      for(let e in this.repos){
        for(let i in this.arrid){
            if(this.repos[e].id == this.arrid[i] ){
              resultd.push({"id": this.repos[e].id,"name": this.repos[e].name})
                }
        }


      }
      //console.log(result1)
      //console.log(resulttodo)
      //console.log(resultd)
      this.done=resultd
     //console.log(result)
     this.todo=result1
     ////console.log(this.done)
    }
    else{
    return

    }





  },
  (error) => {
    Swal.fire({
      text: 'Un problème est survenu! '+error,

    })

    this.spinnerreportfav.hide();
  })
  }


  move(){
    /* this.done=this.todo
    this.todo=[]
     */

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };




    this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/units'
    this.http.get(this.URL ,requestOptions).subscribe((response)=>{

    var listvehiculee:any =response

    this.lengthTotal = listvehiculee.length


    this.repos =  listvehiculee.vehicles
    //console.log(this.repos)





    let resultid : any[]=[]

      for(let e in this.repos){
        resultid.push({"id": this.repos[e].id,"name": this.repos[e].name})

        this.test.push(this.repos[e].id)
      }



    this.done=resultid

    this.todo=[]
    //console.log(this.done)
    },
    (error) => {
      Swal.fire({
        text: 'Un problème est survenu! '+error,

      })


    })
      }



      remove(){
        /* this.todo=this.done
        this.done=[] */

        const headerDict = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Access-Control-Allow-Headers': 'Content-Type',
        }

        const requestOptions = {
          headers: new HttpHeaders(headerDict),
        };




        this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/units'
      this.http.get(this.URL ,requestOptions).subscribe((response)=>{

        var listvehiculee:any =response

        this.lengthTotal = listvehiculee.length


        this.repos =  listvehiculee.vehicles
        //console.log(this.repos)






        let resultid : any[]=[]

        for(let e in this.repos){
          resultid.push({"id": this.repos[e].id,"name": this.repos[e].name})
          //this.test.push(this.repos[e].id)
        }

      this.todo=resultid
      this.done=[]
      this.test=[]
      //console.log(this.done)
      },
      (error) => {
        Swal.fire({
          text: 'Un problème est survenu! '+error,

        })


      })

          }





          move1(){
            /* this.done=this.todo
            this.todo=[]
             */

            const headerDict = {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Access-Control-Allow-Headers': 'Content-Type',
            }

            const requestOptions = {
              headers: new HttpHeaders(headerDict),
            };




            this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/drivers'
            this.http.get(this.URL ,requestOptions).subscribe((response)=>{

            var listvehiculee:any =response

            this.lengthTotal = listvehiculee.length


            this.repos =  listvehiculee.drivers
            //console.log(this.repos)






            let resultid : any[]=[]

            for(let e in this.repos){
              resultid.push({"id": this.repos[e].id,"name": this.repos[e].name})

              this.test.push(this.repos[e].id)
            }
            //console.log(resultid)
            this.done=resultid
            this.todo=[]
            //console.log(this.done)
            },
            (error) => {
              Swal.fire({
                text: 'Un problème est survenu! '+error,

              })

              this.spinnerreportfav.hide();
            })
              }
              remove1(){
                /* this.todo=this.done
                this.done=[] */

                const headerDict = {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'Access-Control-Allow-Headers': 'Content-Type',
                }

                const requestOptions = {
                  headers: new HttpHeaders(headerDict),
                };




                this.URL = environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/drivers'
              this.http.get(this.URL ,requestOptions).subscribe((response)=>{

                var listvehiculee:any =response

                this.lengthTotal = listvehiculee.length


                this.repos =  listvehiculee.drivers
                //console.log(this.repos)








               let resultid : any[]=[]

      for(let e in this.repos){
        resultid.push({"id": this.repos[e].id,"name": this.repos[e].name})

        //this.todo.push(this.repos[e].name)
      }
              //console.log(resultid)
              this.todo=resultid
              this.done=[]
              this.test=[]
              //console.log(this.done)
              },
              (error) => {
                Swal.fire({
                  text: 'Un problème est survenu! '+error,

                })

                this.spinnerreportfav.hide();
              })

                  }


    show_fl_cond(){
      this.desc_fl_cond=true
      this.mode="conducteur"
      this.descr_veh=false

      this.rap_fl_v=false;
    this.rap_d_v=false;

    this.rap_fl_c=false;
    this.rap_d_c=false;
    //console.log(this.mode)
    this.todo=[]

    }
  show_vehicule(){
    this.veh=!this.veh
  }
  show_score(){
    this.scr=!this.scr

  }
  show_score2(){
    this.scr2=!this.scr2

  }
  show_report_fl_v(){
    this.rap_fl_v=true;
    this.rap_d_v=false;

    this.rap_fl_c=false;
    this.rap_d_c=false;

    this.descr_veh=false

    this.desc_fl_cond=false
    this.descr_fl_veh=false;
    this.done=[]
    this.listvehicule()
  }
  show_report_det_v(){
    this.rap_fl_v=false;
    this.rap_d_v=true;

    this.rap_fl_c=false;
    this.rap_d_c=false;

    this.descr_veh=false

    this.desc_fl_cond=false;
    this.desc_det_veh=false;
    this.done=[]
    this.listvehicule()
  }

  show_report_fl_c(){
    this.rap_fl_v=false;
    this.rap_d_v=false;

    this.rap_fl_c=true;
    this.rap_d_c=false;

    this.descr_veh=false

    this.desc_fl_cond=false
    this.done=[]
    this.listcond()

  }
  show_report_det_c(){
    this.rap_fl_v=false;
    this.rap_d_v=false;

    this.rap_fl_c=false;
    this.rap_d_c=true;

    this.descr_veh=false

    this.desc_fl_cond=false
    this.desc_det_cond=false
    this.done=[]
    this.listcond()
  }

    drop(event: CdkDragDrop<string[]>) {
      if (event.previousContainer === event.container) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        //console.log(this.todo)
        //console.log(this.done)

      } else {
        transferArrayItem(event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex);
          //console.log(this.todo)
          //console.log(this.done)
          //console.log(event.container.data)
          this.test=[]
          for(let e in this.done){
            this.test.push(this.done[e].id)
          }

//console.log(this.test)

}
    }



}

@Component({
  selector: 'PdfDom',
  templateUrl: './PdfDom.html',
  styleUrls: ['./add-favoris-report.component.scss']
})
export class PdfDomComponent implements OnInit {
  url: any;

constructor(public traslateService: TraslateService){

}
  ngOnInit(): void {
    this.traslateService.currentfavdataQuote.subscribe(data=>{
      this.url =data
    })

  }


}
